import { Paper } from '@mui/material';
import type { ReactNode } from 'react';

export interface StatRowProps {
  readonly ariaLabel: string;
  readonly children: ReactNode;
  readonly columns?: number;
}

export function StatRow({ ariaLabel, children, columns = 4 }: StatRowProps) {
  return (
    <Paper
      aria-label={ariaLabel}
      component="section"
      variant="outlined"
      sx={{
        // The Aurora KPI row reads as one surface split into cells, not as detached cards. The
        // container paints the divider colour and a 1px grid gap lets it show through as hairlines —
        // this needs no per-cell nth-child border arithmetic and stays correct at every breakpoint,
        // however many children are passed.
        bgcolor: 'divider',
        display: 'grid',
        gap: '1px',
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'repeat(2, minmax(0, 1fr))',
          lg: `repeat(${columns}, minmax(0, 1fr))`,
        },
        minWidth: 0,
        overflow: 'hidden',
        '& > *': { bgcolor: 'background.paper' },
      }}
    >
      {children}
    </Paper>
  );
}
